/**
 * Compatibility shim for legacy Statsig imports.
 * The codebase migrated from Statsig to GrowthBook/analytics.
 * This shim re-exports the equivalent types and no-op functions.
 */

import {type Events} from '#/analytics/metrics/types'
export {toClout} from '#/analytics/metrics/utils'

// LogEvents was the Statsig name for the analytics Events type
export type LogEvents = Events

// logEvent is a no-op stub; callers should migrate to useAnalytics().metric()
export function logEvent<K extends keyof LogEvents>(
  _event: K,
  _data: LogEvents[K],
): void {}

// useGate returns a function that always returns false (no-op gate)
export function useGate(): (gate: string) => boolean {
  return (_gate: string) => false
}

// gate standalone function always returns false
export function gate(_gate: string): boolean {
  return false
}
